import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndexComponent } from './pages/index/index.component';
import { LayoutComponent } from './shared/layout/layout.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AccountDeleteComponent } from './pages/account-delete/account-delete.component';

const title = "Casa del Café"
const description = "Casa del Café"

const routes: Routes = [
  {
		path: 'auth',
		loadChildren: () => import( './auth/auth.module').then( m => m.AuthModule),
		data: { title: title, description: description}
	},
  {
		path: 'eliminar-cuenta',
		loadChildren: () => import( './pages/account-delete/account-delete.module').then( m => m.AccountDeleteModule),
		data: { title: title, description: description}
	},
  {
    path: 'terminos-y-condiciones-de-uso', 
    loadChildren: () => import('./pages/privacity/privacity.module').then(m => m.PrivacityModule),
    data: { type: 'terms' }
  },
  {
    path: 'politica-general-sobre-la-privacidad-en-linea', 
    loadChildren: () => import('./pages/privacity/privacity.module').then(m => m.PrivacityModule),
    data: { type: 'policy' }
  },
  {
		path: '',
		component: LayoutComponent,
		children: [
      {
        path: '',loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
      }
    ]
  },
  { path: '**', component: NotFoundComponent }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
